var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10848_3009)",
    filter: "url(#filter0_d_10848_3009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4347 10H13.2174C13.4095 10 13.5652 10.1557 13.5652 10.3478V13.1304C13.5652 13.3225 13.4095 13.4783 13.2174 13.4783H10.4347C10.2426 13.4783 10.0869 13.3225 10.0869 13.1304V10.3478C10.0869 10.1557 10.2426 10 10.4347 10Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6086 10H17.3912C17.5833 10 17.739 10.1557 17.739 10.3478V13.1304C17.739 13.3225 17.5833 13.4783 17.3912 13.4783H14.6086C14.4165 13.4783 14.2607 13.3225 14.2607 13.1304V10.3478C14.2607 10.1557 14.4165 10 14.6086 10Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4347 14.1738H13.2174C13.4095 14.1738 13.5652 14.3295 13.5652 14.5217V17.3043C13.5652 17.4964 13.4095 17.6521 13.2174 17.6521H10.4347C10.2426 17.6521 10.0869 17.4964 10.0869 17.3043V14.5217C10.0869 14.3295 10.2426 14.1738 10.4347 14.1738Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6086 14.1738H17.3912C17.5833 14.1738 17.739 14.3295 17.739 14.5217V17.3043C17.739 17.4964 17.5833 17.6521 17.3912 17.6521H14.6086C14.4165 17.6521 14.2607 17.4964 14.2607 17.3043V14.5217C14.2607 14.3295 14.4165 14.1738 14.6086 14.1738Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7824 10H21.565C21.7571 10 21.9128 10.1557 21.9128 10.3478V13.1304C21.9128 13.3225 21.7571 13.4783 21.565 13.4783H18.7824C18.5903 13.4783 18.4346 13.3225 18.4346 13.1304V10.3478C18.4346 10.1557 18.5903 10 18.7824 10Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7824 14.1738H21.565C21.7571 14.1738 21.9128 14.3295 21.9128 14.5217V17.3043C21.9128 17.4964 21.7571 17.6521 21.565 17.6521H18.7824C18.5903 17.6521 18.4346 17.4964 18.4346 17.3043V14.5217C18.4346 14.3295 18.5903 14.1738 18.7824 14.1738Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4347 18.5215H13.2174C13.4095 18.5215 13.5652 18.6772 13.5652 18.8693V21.6519C13.5652 21.844 13.4095 21.9997 13.2174 21.9997H10.4347C10.2426 21.9997 10.0869 21.844 10.0869 21.6519V18.8693C10.0869 18.6772 10.2426 18.5215 10.4347 18.5215Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6086 18.5215H17.3912C17.5833 18.5215 17.739 18.6772 17.739 18.8693V21.6519C17.739 21.844 17.5833 21.9997 17.3912 21.9997H14.6086C14.4165 21.9997 14.2607 21.844 14.2607 21.6519V18.8693C14.2607 18.6772 14.4165 18.5215 14.6086 18.5215Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7824 18.5215H21.565C21.7571 18.5215 21.9128 18.6772 21.9128 18.8693V21.6519C21.9128 21.844 21.7571 21.9997 21.565 21.9997H18.7824C18.5903 21.9997 18.4346 21.844 18.4346 21.6519V18.8693C18.4346 18.6772 18.5903 18.5215 18.7824 18.5215Z",
    fill: "#141414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10848_3009",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10848_3009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10848_3009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10848_3009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.7cde4ecdcb5f5e4bf0562689374a44ea.svg";
export { ForwardRef as ReactComponent };